// extracted by mini-css-extract-plugin
export default {"inp":"CustomInputTime_inp__4fWjq","dark":"CustomInputTime_dark__xwLhI"};